import { ProductMetafields } from '../../lib/types'
import { ProductCard } from '../collections/product-card.client'
import styles from '../../assets/scss/components/products/recommended-products.module.scss'
import { useI18n } from '../i18n.client'
import { classNames } from '@shopify/css-utilities'
import { ProductOptionsProvider } from '@shopify/hydrogen'

export const RecommendedProducts: React.FC<{
  isOnGreen?: boolean
  products: ProductMetafields[]
  showBuyButton?: boolean
}> = ({ isOnGreen = false, products, showBuyButton = false }) => {
  const [i18n] = useI18n()

  return (
    <section className="section">
      <div className={classNames(styles.title, isOnGreen && styles.isOnGreen)}>
        {i18n.translate('dream-on-dreamer')}
      </div>
      <div className={styles.gridScrollContainer}>
        <div className={styles.grid}>
          {products
            .filter((product) => !product.variants.nodes.every(({ availableForSale }) => !availableForSale))
            .slice(0, 3)
            .map((product) => (
              <ProductOptionsProvider data={product} key={product.id}>
                <ProductCard
                  eventName="upsell_cart"
                  isOnGreen={isOnGreen}
                  product={product}
                  showBuyButton={showBuyButton}
                />
              </ProductOptionsProvider>
            ))}
        </div>
      </div>
    </section>
  )
}
